import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from 'state/store'
import { Router, Route } from 'react-router-dom'
import history from 'shared/utils/history'
import { AuthProvider, useAuth } from 'shared/utils/auth'
import PrivateRoute from 'shared/utils/auth/PrivateRoute'
import Spinner from 'shared/components/Spinner'
import AuthError from 'shared/components/AuthError'
import { isEmbedded } from 'shared/utils/iframeHandler'
import * as Actions from 'state/actions'

import Analytics from 'analytics/components/Analytics/Analytics.component'

const Main = () => {
  const { loading, authError, login } = useAuth()

  if (loading) { //TODO provide loading page :)
    return <Spinner />
  }

  // A rejected sign-in has no route to land on — PrivateRoute deliberately does
  // not redirect while this is set, so the message is shown here instead.
  if (authError) {
    return <AuthError
      message={authError.message}
      code={authError.error}
      onRetry={login}
    />
  }

  return (
    <Router history={history}>
      <PrivateRoute path="/" component={Analytics} />
    </Router>
  )
}

const EmbeddedMain = () => {
  useEffect(() => {
    console.log('window.agentId:', window.agentId)
    if(isEmbedded() && (window.token?.token || window.token?.isCareAuthenticated)) {
      console.log('window.token:', window.token)
      store.dispatch(Actions.initData({
        activeOrg: window.activeOrganisation,
        token: window.token,
        agentId: window.agentId
      }))
    }
  }, [window.token, window.activeOrganisation, window.agentId])
  if(window.token.token || window.token.isCareAuthenticated)
    return (
      <Router history={history}>
        <Route path="/" component={Analytics} />
      </Router>
    )
  else return <>
  </>
}

const App = () => (
  <Provider store={store}>
    { 
      isEmbedded() 
        ? <EmbeddedMain /> :
        <AuthProvider>
          <Main />
        </AuthProvider>
    }
  </Provider>
)

export default App

